import React, { useState } from "react";
import { Link } from "react-router-dom";

const Nav = () => {
  const [menuToggle, setMenuToggle] = useState(false);

  const handleMenuToggle = () => {
    setMenuToggle(!menuToggle);
  };

  const handleLinkClick = () => {
    setMenuToggle(false);
  };

  return (
    <nav>
      <ul class="hidden md:flex flex-row font-extrabold font-karla mx-2 p-2 md:text-base text-xs">
        <Link to="/#home">
          <li class="mx-2 cursor-pointer">Home</li>
        </Link>
        <a href="/#about">
          <li class="mx-2 cursor-pointer">About</li>
        </a>

        <a href="/#specials">
          <li class="mx-2 cursor-pointer">Menu</li>
        </a>

        <a href="/reservations">
          <li class="mx-2 cursor-pointer">Reservations</li>
        </a>

        <a href="/#specials">
          <li class="mx-2 cursor-pointer">Order Online</li>
        </a>

        <a href="/#reviews">
          <li class="mx-2 cursor-pointer">Login</li>
        </a>
      </ul>

      <div class="md:hidden max-w-screen-xl flex flex-wrap items-center justify-between mx-auto p-4">
        <button
          onClick={handleMenuToggle}
          type="button"
          class="inline-flex items-center justify-center p-2 w-10 h-10 ml-3 text-sm text-gray-500 rounded-lg hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-gray-200 dark:text-gray-400 dark:hover:bg-gray-700 dark:focus:ring-gray-600"
          aria-controls="navbar-hamburger"
          aria-expanded="false"
        >
          <span class="sr-only">Open main menu</span>
          <svg
            class="w-5 h-5"
            aria-hidden="true"
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 17 14"
          >
            <path
              stroke="currentColor"
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="M1 1h15M1 7h15M1 13h15"
            />
          </svg>
        </button>
        <div
          class={menuToggle ? "flex absolute top-12" : "hidden w-full"}
          id="navbar-hamburger"
        >
          <ul class="flex flex-col font-medium mt-4 rounded-lg bg-gray-50 dark:bg-gray-800 dark:border-gray-700">
            <li>
              <Link
                to="/#home"
                class="block py-2 pl-3 pr-4 text-white bg-blue-700 rounded dark:bg-blue-600"
                aria-current="page"
                onClick={handleLinkClick}
              >
                Home
              </Link>
            </li>
            <li>
              <a
                href="/#about"
                class="block py-2 pl-3 pr-4 text-gray-900 rounded hover:bg-gray-100 dark:text-gray-400 dark:hover:bg-gray-700 dark:hover:text-white"
                onClick={handleLinkClick}
              >
                About
              </a>
            </li>
            <li>
              <a
                href="/#specials"
                class="block py-2 pl-3 pr-4 text-gray-900 rounded hover:bg-gray-100 dark:text-gray-400 md:dark:hover:text-white dark:hover:bg-gray-700 dark:hover:text-white"
                onClick={handleLinkClick}
              >
                Menu
              </a>
            </li>
            <li>
              <a
                href="/#reviews"
                class="block py-2 pl-3 pr-4 text-gray-900 rounded hover:bg-gray-100 dark:text-gray-400 dark:hover:bg-gray-700 dark:hover:text-white"
                onClick={handleLinkClick}
              >
                Reviews
              </a>
            </li>
            <li>
              <a
                href="/reservations"
                class="block py-2 pl-3 pr-4 text-gray-900 rounded hover:bg-gray-100 dark:text-gray-400 dark:hover:bg-gray-700 dark:hover:text-white"
                onClick={handleLinkClick}
              >
                Reservations
              </a>
            </li>
            <li>
              <a
                href="/#footer"
                class="block py-2 pl-3 pr-4 text-gray-900 rounded hover:bg-gray-100 dark:text-gray-400 dark:hover:bg-gray-700 dark:hover:text-white"
                onClick={handleLinkClick}
              >
                Contact
              </a>
            </li>
          </ul>
        </div>
      </div>
    </nav>
  );
};

export default Nav;
